import { namespace } from 'vuex-class';
import { BindingHelpers } from 'vuex-class/lib/bindings';
import { IDocumentContentState } from '@/document-view/document-content/store/document-content.types';

export const documentContentNamespace = 'documentView/documentContent';
export const DocumentContent: BindingHelpers = namespace(documentContentNamespace);

export const state: IDocumentContentState = {
  pageWidth: 0,
  revisionsLoading: false,
  updateFailed: false,
};

export enum EDocumentContentMutation {
  SetPageWidth = 'setPageWidth',
}

export enum EDocumentContentAction {
  SetPageWidth = 'setPageWidth',
}
